



































































































import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import PerformanceCustomerDetailActivities from '@/componentsV2/templates/PerformanceCustomerDetailActivities/PerformanceCustomerDetailActivities.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';
import CustomerHeader from '@/componentsV2/molecules/CustomerHeaderV2/CustomerHeader.vue';
import CustomerWallet from '@/componentsV2/templates/CustomerWalletV2/CustomerWallet.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { Picture } from '@/components/atoms';

import PerformanceOverviewService from '@/api/PerformanceOverview';

import { EBusinessReportType } from '@/models/business';

import { getWordInitials } from '@/utils/getWordInitials';
import eventBus from '@/utils/eventBus';
import { abbreviateNumber } from '@/utils/currency';
import { treatValue } from '@/utils/moneyTreatments';
import DateUtils from '@/utils/DateUtils';
import { parseToBoolean } from '@/utils/parseToBoolean';

enum EInsight {
  SEND_OFFER = 'send-offer',
  SEND_COINS = 'award-coins'
}

interface IInsightItem {
  label: string;
  key: EInsight;
  reportType?: string[];
}

@Component<CustomerDetail>({
  components: {
    Page,
    SectionWrapper,
    PerformanceCustomerDetailActivities,
    AnalyticsCardList,
    CustomerHeader,
    CustomerWallet,
    FilledButton,
    Picture
  }
})
export default class CustomerDetail extends Vue {
  performanceOverviewService = new PerformanceOverviewService();

  customerId = '';
  customer: any = {};
  profileSidebarStickyEnabled: boolean = false;

  breadcrumbs = [
    {
      label: 'Members',
      path: '/performance/customer-center'
    },
    {
      label: 'Member profile'
    }
  ];

  reportValues: Record<string, AnalyticsCardListItem> = {
    totalRedemptions: {
      infos: {
        description: 'Total redemptions',
        amount: 0,
        tooltipText: ''
      },
      reportType: [EBusinessReportType.OFFER, EBusinessReportType.OFFER_COINS]
    },
    totalSavedOffer: {
      infos: {
        description: 'Offers saved',
        amount: 0,
        tooltipText: ''
      },
      reportType: [EBusinessReportType.OFFER]
    },
    totalRedeemedOffer: {
      infos: {
        description: 'Offers redeemed',
        amount: 0,
        tooltipText: ''
      },
      reportType: [EBusinessReportType.OFFER_COINS]
    },
    lifetimeCoins: {
      infos: {
        description: 'Lifetime Coins',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 2
      },
      reportType: [EBusinessReportType.OFFER_COINS, EBusinessReportType.COIN]
    },
    redeemedCoins: {
      infos: {
        description: 'Redeemed Coins',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 2
      },
      reportType: [EBusinessReportType.OFFER_COINS, EBusinessReportType.COIN]
    },
    averageSpent: {
      infos: {
        description: 'Average spent',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 2
      },
      reportType: [EBusinessReportType.OFFER_COINS]
    },
    totalSpent: {
      infos: {
        description: 'Lifetime spent',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 2
      },
      reportType: [EBusinessReportType.OFFER_COINS, EBusinessReportType.COIN]
    }
  };

  insights: IInsightItem[] = [
    {
      key: EInsight.SEND_COINS,
      label: 'Send Coins',
      reportType: [EBusinessReportType.COIN, EBusinessReportType.OFFER_COINS]
    },
    {
      key: EInsight.SEND_OFFER,
      label: 'Send an offer',
      reportType: [EBusinessReportType.OFFER, EBusinessReportType.OFFER_COINS]
    }
  ];

  get tPrefix() {
    return 'performance.memberDetail';
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get activitiesTitle() {
    if (!this.customer) return '';

    return `Activities for ${this.customer.name || '...'}`;
  }

  get cachedCustomerList() {
    return this.$store.getters['performance/getCustomerCenterState'].list;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get isReportTypeOfferOnly() {
    return this.reportType === EBusinessReportType.OFFER;
  }

  get reportType() {
    return this.businessInfo.reportType;
  }

  get favoritedIcon() {
    return require(`@/assets/img/members/favorited-icon.png`);
  }

  get transformedReportValues() {
    const result = Object.entries(this.reportValues)
      .map(([key, value]) => ({
        ...value,
        infos: {
          ...value.infos,
          tooltipText: this.$t(`${this.tPrefix}.reports.${key}.tooltip`)
        }
      }))
      .filter(item =>
        item.reportType ? item.reportType.includes(this.reportType) : true
      );

    return result;
  }

  get filteredInsights() {
    const result = this.insights.filter(item =>
      item.reportType ? item.reportType.includes(this.reportType) : true
    );

    return result;
  }

  get showFavorited() {
    return this.reportType !== EBusinessReportType.COIN;
  }

  mounted() {
    this.getCustomerDetail({ customerId: this.customerId });
    (document.querySelector(
      '.container-scrollable'
    ) as HTMLElement).addEventListener('scroll', this.onScroll);
  }

  created() {
    const customerId = this.$route.params.customerId;

    if (customerId) {
      this.customerId = customerId;
    }

    eventBus.$on('reloadCustomerDetail', this.reloadCustomerDetail);
  }

  beforeDestroy() {
    eventBus.$off('reloadCustomerDetail', this.reloadCustomerDetail);
    (document.querySelector(
      '.container-scrollable'
    ) as HTMLElement).removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const scrollElement = document.querySelector(
      '.container-scrollable'
    ) as HTMLElement;
    this.profileSidebarStickyEnabled =
      !this.isMobileDevice && scrollElement.scrollTop > 0;
  }

  goBack() {
    this.$router.back();
  }

  formatedCustomerData(customer: any) {
    const {
      name,
      lastname,
      createdAt,
      birthday,
      pendingCoins,
      availableCoins,
      totalRedemptions,
      totalSpent,
      image,
      lastPurchaseValue,
      lastPurchase,
      lastMemberActivityAt,
      isFavoritedBusiness
    } = customer;

    return {
      ...customer,
      fullName: `${name} ${lastname}`,
      formatedCreatedAt: DateUtils.formattedDate({
        date: createdAt,
        format: this.isMobileDevice ? 'MMM YYYY' : 'MMMM YYYY'
      }),
      birthday: birthday
        ? DateUtils.formattedDate({ date: birthday, format: 'MMM, DD' })
        : '',
      nameInitials: getWordInitials(`${name} ${lastname}`),
      pendingCoins: treatValue(pendingCoins || 0),
      totalRedemptions: totalRedemptions || 0,
      totalSpent: totalSpent || 0,
      availableBalance: treatValue(availableCoins || 0),
      avatarUrl: (image && image.small) || '',
      lastPurchaseValue: treatValue(lastPurchaseValue || 0),
      lastTransaction: lastPurchase
        ? DateUtils.formattedDate({ date: lastPurchase, applyTimezone: true })
        : '',
      lastActivity: lastMemberActivityAt
        ? DateUtils.formattedDate({
            date: lastMemberActivityAt,
            format: 'MM/DD/YYYY',
            applyTimezone: true
          })
        : '',
      isFavoritedBusiness: parseToBoolean(isFavoritedBusiness)
    };
  }

  reloadCustomerDetail() {
    this.getCustomerDetail({
      customerId: this.customerId,
      showLoader: false,
      updateCachedCustomers: true
    });

    const containerScrollableEl = document.querySelector(
      '.container-scrollable'
    );

    if (containerScrollableEl) {
      containerScrollableEl.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  formattedCoin(coin: string) {
    const fractionDigits = 2;

    return abbreviateNumber(Number(coin) || 0, fractionDigits);
  }

  coinLabel(amount: string) {
    return `${this.formattedCoin(amount)} ${this.$tc(
      `common.pluralize.coin`,
      Number(amount) || 1
    )}`;
  }

  async getCustomerDetail({
    customerId,
    showLoader = true,
    updateCachedCustomers = false
  }: {
    customerId: string;
    showLoader?: boolean;
    updateCachedCustomers?: boolean;
  }) {
    if (showLoader) {
      setTimeout(() => this.$showLoader(), 0);
    }

    const response = await this.performanceOverviewService.getCustomerDetail(
      customerId
    );

    if (showLoader) this.$hideLoader();

    if (response.status !== 200) return;

    const formatedCustomer = this.formatedCustomerData(response.data);

    if (updateCachedCustomers) {
      const newCustomers = this.cachedCustomerList.map(
        (customer: Record<string, any>) => {
          if (customer && customer.id === formatedCustomer.id) {
            return {
              ...customer,
              availableCoins: this.coinLabel(formatedCustomer.availableCoins),
              rewardedCoins: this.coinLabel(formatedCustomer.rewardedCoins),
              purchasedCoins: this.coinLabel(formatedCustomer.purchasedCoins),
              status: formatedCustomer.status
            };
          }

          return customer;
        }
      );

      this.$store.dispatch('performance/SET_LIST_DATA', {
        context: 'customerCenter',
        list: newCustomers
      });
    }

    this.customer = formatedCustomer;

    this.setReportValues(formatedCustomer);
  }

  setReportValues(customer: any) {
    const reportKeys = Object.keys(this.reportValues);
    const cardsWithSymbol = ['averageSpent', 'totalSpent'];

    for (const key of reportKeys) {
      if (!customer[key]) continue;

      if (cardsWithSymbol.includes(key)) {
        this.reportValues[key].infos.prefixAmount = this.currencySymbol;
      }

      this.reportValues[key].infos.amount = customer[key] || '0';
    }
  }

  handleInsightClick(insightKey: EInsight) {
    switch (insightKey) {
      case EInsight.SEND_OFFER:
        this.handleOpenModal('sendAnOfferModal', {
          customerId: this.customerId,
          customerName: this.customer.fullName
        });

        this.handleAnalytcsModals('Send an offer');

        break;

      case EInsight.SEND_COINS:
        this.handleOpenModal('awardCoinsModal', {
          customerName: this.customer.fullName,
          customerId: this.customerId
        });

        this.handleAnalytcsModals('Award coins');

        break;

      default:
        break;
    }
  }

  handleAnalytcsModals(category: string) {
    this.$analytics({
      eventCategory: `Customer profile - ${category}`,
      eventAction: 'click',
      eventLabel: `${this.customer.status} customer`
    });
  }

  handleOpenModal(modalName: string, modalProps: Record<string, any> = {}) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        modalName,
        false,
        true,
        true,
        true,
        true
      ),
      modalProps
    );
  }
}
